import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import BaseFieldModel from "@/core/components/input-widget/BaseFieldModel";

export default class TemplateModel extends BaseModel {
  uuid = null;
  key = null;
  enable_sms = false;
  enable_email = false;
  to = [];
  sms_to = [];
  include_attachment = false;
  template_type = null;
  body = {};
  subject = {};
  sms_body = {};

  static TRANSLATABLE_FIELDS = ['subject', 'body', 'sms_body'];

  rules = {
    key: 'required',
    enable_sms: 'required',
    enable_email: 'required',
    from_address: 'email',
  };

  attributeLabels = {
    key: i18n.t('Template Type'),
    body: i18n.t('Body'),
    subject: i18n.t('Subject'),
    sms_sender: i18n.t('Sender'),
    sms_body: i18n.t('Body'),
    to: i18n.t('To'),
    bcc: i18n.t('BCC'),
    from_address: i18n.t('From Address'),
    sms_to: i18n.t('To'),
    enable_sms: i18n.t('Enable Text Message Notification'),
    enable_email: i18n.t('Enable Email Notification'),
    change_from_to_logged_in: i18n.t('Send From Logged in User'),
    include_attachment: i18n.t('Include PDF Attachment'),
  };

  toJSON() {
    let data = super.toJSON();
    delete data.variables;
    delete data.template_type;
    return data;
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    // Following code here is cause of ckeditor. It does not accept null as value, only empty strings
    if (!this.body) {
      this.body = ''
    }
    this.initTranslatableFields(this);
  }

  getEmailFields() {
    return [
      new BaseFieldModel({type: 'text', key: 'subject', label: this.attributeLabels['subject'], translatable: true}),
      new BaseFieldModel({type: 'ckeditor', key: 'body', label: this.attributeLabels['body'], translatable: true}),
    ]
  }

  getSmsFields() {
    return [
      new BaseFieldModel({
        type: 'textarea', key: 'sms_body', label: this.attributeLabels['sms_body'], translatable: true
      }),
    ]
  }

}

defineTranslatableProperties(TemplateModel);

